export { default } from './MACPInspectionProps.component';
